<template>
  <div class="option-btn-group single">
    <div class="select-wrapper" v-show="showSelect">
      <div class="btn-select reduce" @click="handleReduce"></div>
      <van-field class="select-number" type="digit" v-model="vote_number" />
      <div class="btn-select add" @click="handleAdd"></div>
    </div>
    <div class="flex-box" v-show="showSelect">
      <van-button round type class="single-vote-btn" @click="showSelect = false">取消</van-button>
      <van-button round type class="single-vote-btn" @click="handleSingleVote">确定</van-button>
    </div>
    <van-button v-show="!showSelect" round type class="single-vote-btn" @click="handleShowSelect" :disabled="disabled">
      {{ voteText }}
    </van-button>
  </div>
</template>



<script>
export default {
  name: "",
  props: {
    // maxCount: Number | String,
    activeTab: { // 组合投票时，当前选项所在的tab
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    index: Number | String,
    voteText: String,
  },
  data() {
    return {
      vote_number: 1,
      showSelect: false,
      // 最大投票数 单选可用
      maxCount: null
    }
  },
  components: {
  },
  computed: {},
  watch: {},
  methods: {
    handleReduce() {
      this.vote_number--
      if (this.vote_number <= 1) {
        this.vote_number = 1
      }
    },
    handleAdd() {
      const isGroup = this.$store.state.voteInfo.vote_list && this.$store.state.voteInfo.vote_list.length ? true : false;
      const temp = isGroup ? this.$store.state.voteInfo.vote_list[this.activeTab] : this.$store.state.voteInfo;
      const maxCount = temp.surplus_ticket;
      this.vote_number++
      if (this.vote_number > maxCount) {
        this.vote_number = maxCount
        this.$toast.fail(`一次最多可投${maxCount}票`);
      }
    },
    // 一人一票的时候，直接投票
    handleShowSelect() {
      // console.log('一人一票的时候，直接投票剩余票数', this.$store.state.voteInfo)
      const { vote_list } = this.$store.state.voteInfo
      const temp = vote_list && vote_list.length ? vote_list[this.activeTab] : this.$store.state.voteInfo
      console.log('一人一票的时候，直接投票 temp', temp)
      // return
      if (temp.restrict.everyone_count == 1 || temp.restrict.same_option_count == 1 || temp.surplus_ticket <= 1 || temp.option_rate == 1) {
        this.$emit("single-vote", this.index, this.vote_number)
      } else {
        this.showSelect = !this.showSelect
      }
    },
    handleSingleVote() {
      this.showSelect = !this.showSelect
      this.$emit("single-vote", this.index, this.vote_number)
    }
  },
  created() {

  },
  mounted() { },
}
</script>

<style scoped>
.select-wrapper {
  width: 100%;
  max-width: 4rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  font-size: .4rem;
}

.btn-select {
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  flex-shrink: 0;
}

.add {
  background: url(../assets/images/icon-add.png) center center/.64rem no-repeat;
}

.reduce {
  background: url(../assets/images/icon-reduce.png) center center/.64rem no-repeat;
}

.select-number>>>.van-field__control {
  text-align: center;
}

.select-number>>>.van-field__body {
  height: 100%;
}

.select-number.van-cell:not(:last-child)::after {
  left: 0;
  display: none;
}

.single-vote-btn {
  /* margin-top: .1rem; */
}

.flex-box {
  display: flex;
  justify-content: space-around;
}

.flex-box .single-vote-btn {
  min-width: 1rem;
  width: 1.5rem;
  /* flex: 1; */
}
</style>